import React from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { navigate } from 'gatsby'

import {
  FormGroup,
  Paragraph,
  H2,
  H1,
  Flex,
  Span,
} from '@allied-solutions/affinity'

import { useFetchBorrower } from '../../../hooks'
import {
  AppLayout,
  BackButton,
  ButtonGroup,
  Hint,
  InfoBox,
  NextButton,
  SubmitInsuranceLayout,
} from '../../../components'

const LookupVehiclePage = ({ location }) => {
  const { handleSubmit: fetchBorrower } = useFetchBorrower(
    '/no-reference-id/confirm-identity/'
  )

  const handleSubmit = async (values, bag) => {
    return (

      fetch(`${process.env.GATSBY_API_URL}/reference-ids/vehicle?VinEndsWith=${values.lastpart_vin}&LastName=${values.last_name}&PostalCodeStartsWith=${values.postal_code}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true'
        }
      })
        // handle HTTP status codes
        .then(res => {
          if (res.ok) return res.json()

          if (res.status === 404) throw new Error('Not found.')
        })

        // success
        .then(data => {
          fetchBorrower({ refId: data.ReferenceIds[0] }, bag)
        })

        // error
        .catch(error => {
          // console.log(error)
          navigate('/submit-insurance/no-reference-id/upload-documents/')
        })
    )
  }

  return (
    <SubmitInsuranceLayout location={location}>
      <Formik
        initialValues={{
          last_name: '',
          postal_code: '',
          lastpart_vin: '',
        }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          last_name: Yup.string().required('Please fill out this field.'),
          postal_code: Yup.string().required('Please fill out this field.'),
          lastpart_vin: Yup.string()
            .matches(/[0-9]/, 'Please enter numbers only.')
            .required('Please fill out this field.')
            .length(5, 'Please enter ${length} digits.'), // eslint-disable-line no-template-curly-in-string
        })}
      >
        {props => (
          <Form noValidate>
            <AppLayout
              leftSide={
                <>
                  <Paragraph
                    mb={6}
                    typeStyle="labelLarge"
                    textAlign="left"
                    color="gray600"
                  >
                    Look up my account
                  </Paragraph>
                  <H1 className="h6" typeStyle="h6" fontSize="28px">
                    You chose to look up a loan on a vehicle.
                  </H1>
                  <Paragraph
                    typeStyle="bodyMedium"
                    textAlign="left"
                    color="gray600"
                  >
                    Check your loan documents and fill out this information.
                    Fill out the information as it appears on your loan.
                  </Paragraph>
                </>
              }
              rightSide={
                <InfoBox>
                  <H2
                    className="titleSmall"
                    typeStyle="titleSmall"
                    fontWeight={900}
                    textAlign="left"
                  >
                    Loan lookup for vehicle
                  </H2>
                  <Flex>
                    <Flex.Col colWidth={[12, 6, 12, 12, 6]}>
                      <FormGroup focusStyleTest id="last_name" mt={8} required>
                        <FormGroup.Label visible>
                          Last Name{' '}
                          <Span fontWeight={900} ml={1} color="red1000">
                            *
                          </Span>
                        </FormGroup.Label>
                        <FormGroup.InputGroup>
                          <FormGroup.InputGroup.Input />
                        </FormGroup.InputGroup>
                        <FormGroup.Caption />
                      </FormGroup>
                    </Flex.Col>
                    <Flex.Col colWidth={[12, 6, 12, 12, 6]}>
                      <FormGroup
                        id="postal_code"
                        mt={8}
                        required
                        focusStyleTest
                      >
                        <FormGroup.Label visible fontWeight={900}>
                          Zip Code{' '}
                          <Span fontWeight="bold" ml={1} color="red1000">
                            *
                          </Span>
                        </FormGroup.Label>
                        <FormGroup.InputGroup>
                          <FormGroup.InputGroup.Input />
                        </FormGroup.InputGroup>
                        <FormGroup.Caption />
                      </FormGroup>
                    </Flex.Col>

                    <Flex.Col>
                      {' '}
                      <FormGroup
                        id="lastpart_vin"
                        mt={8}
                        required
                        focusStyleTest
                      >
                        <FormGroup.Label
                          visible
                          fontWeight="bold"
                          hint={
                            <Hint
                              right="0"
                              id="Tooltip--whatsThis-Loan-Number-Vehicle"
                              content="Your VIN can be found on the inside of the driver’s side door or the corner of your windshield."
                            />
                          }
                        >
                          Last five digits of your VIN (Vehicle Identification
                          Number)
                          <Span fontWeight="bold" ml={1} color="red1000">
                            *
                          </Span>
                        </FormGroup.Label>
                        <FormGroup.InputGroup>
                          <FormGroup.InputGroup.Input pattern="[0-9]*" />
                        </FormGroup.InputGroup>
                        <FormGroup.Caption />
                      </FormGroup>
                    </Flex.Col>
                  </Flex>
                </InfoBox>
              }
              footerButtons={
                <ButtonGroup display="flex" justifyContent="flex-end">
                  <BackButton id="NoRefId__Lookup__Button--back" />
                  <NextButton
                    formikProps={props}
                    id="NoRefId__Lookup__Button--next"
                  />
                </ButtonGroup>
              }
            />
          </Form>
        )}
      </Formik>
    </SubmitInsuranceLayout>
  )
}

export default LookupVehiclePage
